// TICKET-01330: Tripletex returns number: 0 when the voucher is created without
// sendToLedger (featureFlags.tripletexVoucherSendToLedger off) — it then sits in
// Bilagsmottak and only gets its bilagsnummer when the accountant books it there.
// 0 is therefore "no number assigned yet", not a real voucher number, and must
// never be shown as one. The internal Tripletex voucher id is only used as a
// fallback when no number was recorded at all (legacy docs).
export function formatTripletexVoucherNo(voucherNumber, voucherId, fallback = '-') {
    if (voucherNumber === 0 || voucherNumber === '0') {
        return fallback;
    }
    return voucherNumber || voucherId || fallback;
}

export default formatTripletexVoucherNo;
